//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import store from "@/store";
import { PLATFORM_BASE_PATH } from "@/assets/js/appConfig";
import FabDrawerMenuAction from "./FabDrawerMenuAction.vue";
import AQBadge from "@/components/Generics/AQBadge/AQBadge.vue";
import { allowAccessibilityColors } from "@/assets/js/appFunc";
import { menuIcons } from "./menuIconsConst.js"

export default {
    name: "FabDrawerMenu",
    components: {FabDrawerMenuAction, AQBadge },
    props: {
            value: { type: Boolean },
            isExternal: { type: Boolean, default: false },
            fromFabInterface: { type: Boolean, default: false },
            menuCollapsed: { type: Boolean, default: false },
            isMobile: { type: Boolean, default: false },
            showTransition: { type: Boolean, default: false},
            maintenanceMsgHeight: { type: Number, default: 0}
        },
    data() {
        return {
            menuIcons: menuIcons,
            appBlockchainEnabled: false,
            mainItems: ["dashboard", "administration", "apps", "tasks"],
            collapsed: this.fromFabInterface,
            platformVersion: "",
            hovered: null,
            menuHovered: false,
            listHover: null,
            menu: "",
            showLegacyChildren: false,
            items: [
                {
                    name: "dashboard",
                    label: this.$t("dashboard.title"),
                    icon: "dashboard",
                    to: `/${PLATFORM_BASE_PATH}`,
                    routerTo: "/",
                    paths: [],
                    displayChildren: false,
                    children: [
                        {
                            name: "mydashboard",
                            title: this.$t("dashboard.myDashboard"),
                            to: "/mydashboard",
                        },
                        {
                            name: "myteamsdashboard",
                            title: this.$t("dashboard.myTeamDashboard"),
                            to: "/myteamsdashboard",
                        }

                    ]
                },
                {
                    name: "appsMainPage",
                    label: this.$t("mainPage.sideBar.apps"),
                    icon: "view_module",
                    to: `/${PLATFORM_BASE_PATH}/applications`,
                    routerTo: "/applications",
                    pathName: "apps",
                    paths: ["applications", "reports", "dataModel", "api", "documents", "userInterfaces", "process", "smartContractList"],
                    displayChildren: false
                },
                {
                    name: "tasks",
                    label: this.$t("mainPage.sideBar.tasks"),
                    icon: "view_list",
                    to: `/${PLATFORM_BASE_PATH}/tasks`,
                    routerTo: "/tasks",
                    pathName: "tasks",
                    paths: [],
                    displayChildren: false,
                    children: [
                        {
                            name: "myOpenTasks",
                            title: this.$t("tasks.myTasks"),
                            queryParams: {tab:"todo"},
                            to: "/tasks/myTasks",
                        },
                        {
                            name: "teamsTasks",
                            title: this.$t("tasks.myTeamsTasks"),
                            queryParams: {tab:"todo"},
                            to: "/tasks/teamTasks",
                        }
                    ]
                },
                {
                    name: "dataStore",
                    label: this.$t("mainPage.sideBar.globalFeatures"),
                    icon: "public",
                    to: `/${PLATFORM_BASE_PATH}/dataStore`,
                    routerTo: "/dataStore",
                    paths: ["globalIntegration"],
                    displayChildren: false,
                    children: [
                        {
                            name: "dataStore",
                            title: this.$t("mainPage.sideBar.globalEntities"),
                            to: "/dataStore/dataTables",
                            showLegacy: false
                        },
                        {
                            name: "dataStoreLegacy",
                            title: this.$t("mainPage.sideBar.globalEntities"),
                            to: "/dataStore/dataTablesLegacy",
                            showLegacy: true
                        },
                        {
                            name: "globalIntegration",
                            title: this.$t("mainPage.sideBar.globalIntegration"),
                            to: "/dataStore/connectionsLegacy",
                            showLegacy: true
                        }
                    ]
                },
                {
                    name: "administration",
                    label: this.$t("mainPage.sideBar.settings"),
                    icon: "build",
                    to: `/${PLATFORM_BASE_PATH}/administration`,
                    pathName: "administration",
                    paths: ["processController", "branding"],
                    displayChildren: false,
                    children: [
                        {
                            name: "roles",
                            title: this.$t("adminUsersGroups.usersGroupsTitle"),
                            queryParams: {tab:"users"},
                            to: "/administration/users",
                        },
                        {
                            name: "schedule",
                            title: this.$t("admin.navigation.schedule"),
                            to: "/administration/workSchedule",
                        },
                        {
                            name: "messagingAndComm",
                            title: this.$t("admin.navigation.notSettings"),
                            to: "/administration/messagingAndComm",
                        },
                        {
                            name: "emailTemplates",
                            title: this.$t("admin.navigation.taskNotifications"),
                            to: "/administration/emailTemplates",
                        },
                        {
                            name: "FeaturesMainPage",
                            title: this.$t("admin.navigation.features"),
                            to: "/administration/features",
                        },
                        {
                            name: "Plugins",
                            title: this.$t("admin.navigation.plugins"),
                            to: "/administration/plugins",
                        },
                        {
                            name: "Authentication",
                            title: this.$t("admin.navigation.authentication"),
                            to: "/administration/authentication",
                        }
                        ,{
                            name: "SystemApis",
                            title: this.$t("admin.navigation.systemApis"),
                            to: "/administration/systemApis",
                        },
                        {
                            name: "logs",
                            title: this.$t("admin.navigation.logs"),
                            to: "/administration/logs",
                        },
                        {
                            name: "SSLCertificates",
                            title: this.$t("admin.navigation.SSLCertificates"),
                            to: "/administration/sslCertificates",
                        },
                        {
                            name: "branding",
                            title: this.$t("mainPage.sideBar.branding"),
                            to: "/administration/branding",
                        },
                        {
                            name: "processInspector",
                            title: this.$t("mainPage.sideBar.processInspector"),
                            to: "/administration/processController",
                        }
                    ]
                }
            ],
            windowWidth: null
        };
    },
    watch: {
        menuCollapsed(val) {
            this.collapsed = val;
        },
        getUserIsManager: {
            handler(val) {
                const index = this.items.findIndex(el => el.name === "dashboard");
                this.items[index].label = val ? this.$t("dashboard.title") : this.$t("dashboard.myDashboard");
            },
            immediate: true
        },
        maintenanceMsgHeight: {
            handler() {
                const qDrawer = document.getElementsByClassName("q-drawer")[0];
                if (qDrawer) {
                    qDrawer.style.marginTop = `${this.maintenanceMsgHeight}px`;
                }
            },
            immediate: true
        }
    },
    computed: {
        ...mapGetters("userProfile", ["userCookieInfo", "userDataDetails", "getUserIsManager"]),
        ...mapGetters("main", ["activePage", "lastUpdate", "getInfoApp"]),
        ...mapGetters("apps", ["currentApp", "getCurrentAppUserPermissions", "getUserSystemPermissions"]),
        ...mapGetters("GDM", ["getEntitySelected"]),
        ...mapGetters("dataStore", {getDataStoreEntitySelected: "getEntitySelected"}),
        ...mapState("components", ["isSmallScreen"]),
        localSmallScreen() {
            return localStorage.getItem("localIsSmallScreen") || "";
        },
        smallScreenUpdated() {
            return this.windowWidth < this.$q.screen.sizes.sm;
        },
        menuItems() {
            let items = [...this.items];
                if (!this.isAdmin) {
                    items = items.filter((item) => item.name !== "administration");
                }
                if (!this.isDataStoreManager) {
                    items = items.filter((item) => item.name !== "dataStore");
                }

            if (this.smallScreenUpdated) {
                return items.filter(
                    (item) => !["administration", "dashboard", "dataStore"].includes(item.name)
                );
            }
            return items;
        },
        isAdmin() {
            return !!(
                this.getUserSystemPermissions
                && this.getUserSystemPermissions.hasOwnProperty("A")
                && this.getUserSystemPermissions.A.hasOwnProperty("g")
            );
        },
        isAppCreator() {
            return !!(
                this.getUserSystemPermissions
                && this.getUserSystemPermissions.hasOwnProperty("C")
                && this.getUserSystemPermissions.C.hasOwnProperty("g")
            );
        },
        isDataStoreManager() {
            return !!(
                this.getUserSystemPermissions
                && this.getUserSystemPermissions.hasOwnProperty("D")
                && this.getUserSystemPermissions.D.hasOwnProperty("g")
            );
        }
    },
    mounted() {
        if (process.env.NODE_ENV === "development") {
            this.platformVersion = "N/A on local";
        } else {
            this.getPlatformVersion().then(rsp => {
                this.platformVersion = rsp.data.aurachain.version;
            });
        }
        this.setActiveIcon();
        const isMobile = localStorage.getItem("localIsSmallScreen");
        if (!isMobile) {
            store().dispatch("tasks/getUserDetails").then(data => {
                localStorage.setItem("accessibility", data.colorsAccessibility);
                const hasAccFeature = localStorage.getItem("accessibilityFeature")
                allowAccessibilityColors(data.colorsAccessibility && hasAccFeature === "true");
            });
        }
        this.$emit("menuExpanded");

        this.windowWidth = window.innerWidth;
        this.getLegacyClient().then(res=> {
           this.showLegacyChildren = res.data.isLegacyDatastore
        });
        window.addEventListener("resize", this.updateWindowWidth);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.updateWindowWidth);
    },
    methods: {
        ...mapActions("main", ["getPlatformVersion", "getLegacyClient"]),
        updateWindowWidth() {
            this.windowWidth = window.innerWidth;
        },
        isActive(item, index) {
            const classes = [];
            if (index === this.hovered || index === this.menuHovered || this.listHover === index) {
                classes.push("hover-state");
                setTimeout(() => {
                    this.setActiveIcon();
                }, 0);
            }
            if(this.$router && !["appUserTaskDataViews", "appUserTaskAnalytics", "appUserTask"].includes(this.$route.name) && (this.$route.path.includes(item.pathName) || (this.$route.name && this.$route.name.includes(item.name))
            || item.paths.find(el => this.$route.path.includes(el) && !(this.$route.name === "processInspector" && el === "process")))) {
                classes.push("active");
                setTimeout(() => { this.setActiveIcon() }, 0);
            }
            return classes;
        },
        setActiveIcon() {
            let paths = document.querySelectorAll(".active path");
            paths.forEach(el => {
                el.style.stroke = this.getInfoApp.colorCode;
            })
            paths = document.querySelectorAll(".content-padding:not(.active) path");
            paths.forEach(el => {
                el.style.stroke = "var(--q-color-grey-default)";
            })
            paths = document.querySelectorAll(".content-padding:not(.active).hover-state path");
            paths.forEach(el => {
                el.style.stroke = "var(--q-color-bright)";
            });
        },
        softwareLicensesClick() {
            this.$store.commit("apps/setCurrentApp", {});
            window.location.href = `/${PLATFORM_BASE_PATH}/softwareLicenses`;
        },
        showChildren(item) {
            return !this.collapsed && item.displayChildren && this.availableFilteredChildren(item.children) ? this.filterChildren(item.children) : [];
        },
        filterChildren(children) {
            return children.filter(el => {
                let returnValue = false;
                if (!["teamsTasks", "myteamsdashboard"].includes(el.name)) {
                    if (el.hasOwnProperty('showLegacy')) {
                        if (this.showLegacyChildren || !el.showLegacy) {
                            returnValue = true;
                        }
                    } else {
                        returnValue = true;
                    }
                } else if (this.getUserIsManager) {
                    returnValue = true;
                }
                return returnValue;
            })
        },
        availableFilteredChildren(children) {
            return !this.isSmallScreen && this.filterChildren(children).length > 1;
        },
        mouseEnterBtn(index) {
            if(this.collapsed) {
                this.hovered = index;
            }
        },
        mouseLeaveBtn() {
            if(this.collapsed) {
                setTimeout( () => { this.hovered = null; }, 0);
            }
        },
        mouseEnterMenu(index) {
            if(this.collapsed) {
                this.menuHovered = index;
            }
        },
        mouseLeaveMenu() {
            if(this.collapsed) {
                setTimeout( () => { this.menuHovered = null; }, 0);
            }
        },
        popupMenuSelect(item) {
            this.hovered = null;
            this.menuHovered = null;
            this.goToOption(item);
        },
        setTeamsLogic(item) {
            if (item.name === "myteamsdashboard") {
                localStorage.setItem("isMyTeamDashboard", true);
                this.$store.commit("main/setFromMyTeamsTasksMenu", true);
                this.$root.$emit("teamsDashboard", true);
            } else if (item.name === "mydashboard") {
                localStorage.setItem("isMyTeamDashboard", false);
                this.$store.commit("main/setFromMyTeamsTasksMenu", false);
                this.$root.$emit("teamsDashboard", false);
            } else if (["myOpenTasks", "tasks"].includes(item.name)) {
                this.$store.commit("main/setFromMyTeamsTasksMenu", false);
            } else if (item.name === "teamsTasks") {
                this.$store.commit("main/setFromMyTeamsTasksMenu", true);
            }
            this.$store.commit("apps/setCurrentApp", {});
        },
        menuSelect(item) {
            if (this.collapsed) {
                this.singleOptionMenuClick(item);
            }
        },
        goToOption(item) {
            const checkQueryParam = () => {
                const { queryParams } = item;
                const {query, params} = this.$route;
                let hasSameRoute = true;
                if (["dataStore", "dataStoreLegacy"].includes(item.name)) {
                    hasSameRoute = !(params.tableCode || params.tableId);
                } else if (queryParams) {
                    const [queryParam] = Object.keys(queryParams);
                    hasSameRoute = query[queryParam] && queryParams[queryParam] === query[queryParam];                    
                }
                return hasSameRoute;
            }
            if (this.$route.name === item.name && checkQueryParam()) return;
            this.setTeamsLogic(item);
            if (this.$router) {
                if (item.name === "dataStoreLegacy") {
                    this.$store.commit("GDM/setEntitySelected");
                } else if (item.name === "dataStore") {
                    this.$store.commit("dataStore/setEntitySelected");
                }
                this.$router.push({path: item.to, query: item.queryParams || {}});
            } else {
                localStorage.setItem("fabIntToTeams", item.to === "/tasks/teamTasks");
                window.location.href = `/${PLATFORM_BASE_PATH}${item.to}`;
            }
        },
        optionClicked(item, index) {
            for (let i = 0; i < this.menuItems.length; i++) {
                if (i !== index && this.menuItems[i].displayChildren) {
                    this.menuItems[i].displayChildren = false;
                }
            }
            if (!this.collapsed) {
                if (item.children) {
                    item.displayChildren = !item.displayChildren;
                }
                this.singleOptionMenuClick(item);
            }
        },
        singleOptionMenuClick(item) {
            const checkForTasks = () => (item.name === "tasks" && ["appUserTaskDataViews", "appUserTaskAnalytics", "appUserTask"].includes(this.$route.name));
            if (this.collapsed) {
                this.hovered = null;
                this.menuHovered = null;
                this.menu = true;
                this.hovered = true;
            }
            if (!item.children || !this.availableFilteredChildren(item.children)) {
                this.setTeamsLogic(item);
                if (item.name === "dashboard") {
                    this.$root.$emit("teamsDashboard", false);
                }
                if(!this.$route) {
                    window.location.href = item.to;
                } else if (item.name !== this.$route.name && (!this.$route.path.includes(item.pathName) || checkForTasks()) || this.$route.name === "AddToArchive") {
                    this.$router.push(item.routerTo);
                } else if (this.isSmallScreen) {
                    this.$emit("input", false);
                }
            }
        },
        chevronIcon(item) {
            return item.displayChildren ? "expand_more" : "chevron_right";
        }
    }
};
